import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import type { ChangePasswordFormPayload } from 'services/requests';
import { yupPasswordFormat, yupRepeatPassword, yupPasswordRequired } from 'utils';
import { useCustomForm } from './useCustomForm';
import type { UseCustomFormReturn } from './useCustomForm';

export enum ChangePasswordFieldNames {
  currentPassword = 'currentPassword',
  newPassword = 'newPassword',
  repeatNewPassword = 'repeatNewPassword',
}

export const useChangePasswordForm =
  (): UseCustomFormReturn<ChangePasswordFormPayload> => {
    const schema: yup.SchemaOf<ChangePasswordFormPayload> = yup.object({
      currentPassword: yupPasswordRequired,
      newPassword: yupPasswordFormat,
      repeatNewPassword: yupRepeatPassword('newPassword'),
    });

    const resolver = yupResolver(schema);

    const form = useForm<ChangePasswordFormPayload>({
      mode: 'onSubmit',
      reValidateMode: 'onSubmit',
      resolver,
      defaultValues: {
        currentPassword: '',
        newPassword: '',
        repeatNewPassword: '',
      },
    });

    return useCustomForm(form, resolver);
  };
